import { ReactElement } from "react";

const ErrorPage = (): ReactElement => {
  return (
    <>
      Something went wrong. Please contact Justworks support at{" "}
      <a href="tel: 888-534-1711">(888) 534-1711</a> or email us at{" "}
      <a href="mailto: support@justworks.com">support@justworks.com</a>.
    </>
  );
};

export default ErrorPage;
